'use strict';

angular.module('dekky.forms')
.directive('formWidget', function($compile, $log, $templateCache, $http, $q, formsUtils, $interpolate) {
	return {
		restrict: 'AE',
		require: 'ngModel',
		scope: {
			field: '=',
			model: '=ngModel',
			fieldIndex: '=',
			fieldData: '=',
            disabled: '=?ngDisabled'
		},
		link: function(scope, element, attrs, controller) {
			var theme = scope.field.form.config.theme;

			scope.validators = scope.field.validators;
			scope.options = scope.field.options;
			scope.field.model = scope.model;
			scope.disabled = scope.disabled || false;



			function getTemplateUrl(type) {
				var template = attrs.templateUrl ? attrs.templateUrl :  theme + '/fields/' + type + '.html';

				return $q.when(template);
			}

			function loadTemplate(template) {
				return $http.get(template, {cache: $templateCache})
					.then(function(response) {
						return angular.element(response.data);
					});
			}

			function setValidators(templateElement) {
				angular.forEach(scope.validators, function(validator, validatorName) {
					var validatorValue;

					if (angular.isObject(validator)) {
						validatorValue = 'validators.' + validatorName;
					} else if (angular.isFunction(validator)) {
						validatorValue = 'validators.' + validatorName + '()';
					} else {
						validatorValue = validator;
					}

					angular.element(templateElement[0]).attr(formsUtils.camelToDash(validatorName), validatorValue);
				});

				return $q.when(templateElement);
			}

			function setOptions(templateElement) {
				angular.forEach(scope.options, function(option, optionName) {
					var optionValue;

					if (angular.isObject(option)) {
						optionValue = 'options.' + optionName;
					} else if (angular.isFunction(option)) {
						optionValue = 'options.' + optionName + '()';
					} else {
						optionValue = option;
					}

					if(optionName == 'defaultOption') {
						var defaultOptionTemplate;
						scope.defaultOptionText = option || 'Select...';
						defaultOptionTemplate = '<option value="">{{defaultOptionText}}</option>';
						angular.element(templateElement[0]).prepend($interpolate(defaultOptionTemplate)(scope));
					} else if ( scope.field.type == 'checkbox' && templateElement[0].tagName.toLowerCase() == 'label' ) {
						angular.element(templateElement.children('input')[0]).attr(formsUtils.camelToDash(optionName), optionValue);
					} else {
						angular.element(templateElement[0]).attr(formsUtils.camelToDash(optionName), optionValue);
					}
				});

				return $q.when(templateElement);
			}

			function compileTemplate(template) {
				element.append(template);

				return $compile(element.contents())(scope);
			}

			function linkField(template) {
				return scope.field.link(template, scope, element, attrs, controller);
			}

			getTemplateUrl(scope.field.type)
				.then(loadTemplate)
				.then(setOptions)
				.then(setValidators)
				.then(linkField)
				.then(compileTemplate);
		}
	}
});